import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode } from 'primereact/api';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { TimeToHireApi } from "utils/ApiClients";
import axios from "axios";
import { setPageData } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import CompanySelector from "ATSComponents/Common/CompanySelector";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";

const TimeToHire = () => {
     const dispatch = useDispatch();

    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    const [companyId, setCompanyId] = useState(intialcompanyId);

    const handleCompanyChange = (company) => {
    if (company?.company_id) {
        const selectedId = company.company_id;
        setCompanyId(selectedId);

        const page = Math.floor(first / rows) + 1;
        // fetchTimeToHireDetails(page, rows, selectedId);
    }
    };




     const { first, rows,totalRecords } = useSelector((state) => state.calendar.pagination); 
    // const [pageState, setPageState] = useState({ first: 0, rows: 10 });
    const [loading, setLoading] = useState(true);
    const [selectedJobs, setSelectedJobs] = useState([]);
    const [timeToHire,setTimeToHire] = useState([])
    const toast = useRef(null);
    document.title = "ATS - Reports"

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        job_id: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_number:{ value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_title: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_posting_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        job_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        actual_end_date:{value:null, matchMode: FilterMatchMode.STARTS_WITH},
        number_of_resumes: { value: null, matchMode: FilterMatchMode.EQUALS },
        screening_start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        screening_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        interview_start_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        interview_end_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        offer_release_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        offer_acceptance_date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        hiring_manager: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        time_to_hire_days: { value: null, matchMode: FilterMatchMode.EQUALS },
        time_to_fill: { value: null, matchMode: FilterMatchMode.EQUALS },
    });

    const exportColumns = [
    { title: "Job ID", dataKey: "job_number" },
    { title: "Job Title", dataKey: "job_title" },
    { title: "Job Posting Date", dataKey: "job_posting_date" },
    { title: "Job Start Date", dataKey: "job_start_date" },
    { title: "Job End Date", dataKey: "job_end_date" },
    { title: "Actual End Date", dataKey: "actual_end_date" },
    { title: "Number of Resumes", dataKey: "number_of_resumes" },
    { title: "Screening Start Date", dataKey: "screening_start_date" },
    { title: "Screening End Date", dataKey: "screening_end_date" },
    { title: "Interview Start Date", dataKey: "interview_start_date" },
    { title: "Interview End Date", dataKey: "interview_end_date" },
    // { title: "Offer Release Date", dataKey: "offer_release_date" },
    // { title: "Offer Acceptance Date", dataKey: "offer_acceptance_date" },
    { title: "Hiring Manager", dataKey: "hiring_manager" },
    { title: "Time to Hire (Days)", dataKey: "time_to_hire_days" },
    // { title: "Time to Fill (Days)", dataKey: "time_to_fill" },
];


    const fetchTimeToHireDetails = async(page,page_size,companyId) =>{
        setLoading(true);
        try{
            // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/time_to_hire_report/?page=${page}&page_size${page_size}`)
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/report/time_to_hire_report/?page=${page}&page_size=${page_size}&company_id=${companyId}`);
            const apiData = response?.data?.results || []
            dispatch(setPageData({
                first:(page-1)*page_size,
                rows:page_size,
                totalRecords:response?.data?.count || 0
            }))
            const transformedData = apiData.map((item)=>({
                // job_id:item?.job_id,
                job_number:item?.job_number,
                job_title:item?.job_title,
                job_posting_date:item?.job_posting_date,
                job_start_date:item?.job_start_date,
                job_end_date:item?.job_end_date,
                actual_end_date:item?.actual_end_date,
                number_of_resumes:item?.applications_received,
                screening_start_date:item?.screening_start_date ? item?.screening_start_date.substring(0,10):null,
                screening_end_date:item?.screening_end_date ? item?.screening_end_date.substring(0,10):null,
                interview_start_date:item?.interview_start_date ? item?.interview_start_date.substring(0,10):null,
                interview_end_date:item?.interview_end_date ? item?.interview_end_date.substring(0,10):null,
                offer_release_date:item?.offer_release_date ? item?.offer_release_date.substring(0,10):null,
                offer_acceptance_date:item?.offer_acceptance_date ? item?.offer_acceptance_date.substring(0,10):null,
                hiring_manager:item?.hiring_manager,
                time_to_hire_days:item?.time_to_hire_days,
                time_to_fill:item?.time_to_fill

            }))
            setTimeToHire(transformedData)
            setLoading(false);
        }
        catch(error){
            console.log("error",error.response?.status,error.message,error.response?.data)
            setLoading(false);
        }

    }


    // useEffect(()=>{
    //     const page = Math.floor(first/rows) + 1;
    //     fetchTimeToHireDetails(page,rows)
    // },[first,rows])

    useEffect(() => {
        if (companyId) {
            const page = Math.floor(first / rows) + 1;
            fetchTimeToHireDetails(page, rows, companyId);
        }
    }, [first, rows, companyId]);


       const onPage = (e) => {
        const newPage = Math.floor(e.first/e.rows) + 1
        dispatch(setPageData({
            first:e.first,
            rows:e.rows,
            totalRecords
        }))
        fetchTimeToHireDetails(newPage,e.rows, companyId)
    };

    const onSelectionChange = (e) => {
        setSelectedJobs(e.value);
    };

    const dt = useRef(null);

 const exportCSV = () => {
    const selectionOnly = selectedJobs.length > 0;
    if (!selectionOnly) {
        toast.current.show({
            severity: 'info',
            summary: 'Info',
            detail: 'No rows selected, exporting all data to CSV.',
            life: 3000
        });
    }

    // Preprocess data to ensure correct values are exported
    const exportData = getExportData().map(item => ({
        job_number: item.job_number ?? '',
        job_title: item.job_title ?? '',
        job_posting_date: item.job_posting_date ?? '',
        job_start_date: item.job_start_date ?? '',
        job_end_date: item.job_end_date ?? '',
        actual_end_date: item.actual_end_date ?? '',
        number_of_resumes: item.number_of_resumes ?? '',
        screening_start_date: item.screening_start_date ?? '',
        screening_end_date: item.screening_end_date ?? '',
        interview_start_date: item.interview_start_date ?? '',
        interview_end_date: item.interview_end_date ?? '',
        // offer_release_date: item.offer_release_date ?? '',
        // offer_acceptance_date: item.offer_acceptance_date ?? '',
        hiring_manager: item.hiring_manager ?? '',
        time_to_hire_days: item.time_to_hire_days ?? '',
        // time_to_fill: item.time_to_fill ?? ''
    }));

    // Override the DataTable's export data with preprocessed data
    dt.current.exportCSV({ selectionOnly, exportEmpty: false, data: exportData });
};
    const getExportData = () => selectedJobs.length > 0 ? selectedJobs : timeToHire;


//    const exportPdf = () => {
//     import("jspdf").then((jsPDF) => {
//         import("jspdf-autotable").then(() => {
//             const doc = new jsPDF.default();
//             const dataToExport = getExportData();

//             if (selectedJobs.length === 0) {
//                 toast.current.show({
//                     severity: 'info',
//                     summary: 'Info',
//                     detail: 'No rows selected, exporting all data to PDF.',
//                     life: 3000
//                 });
//             }

//             doc.autoTable({
//                 columns: exportColumns,
//                 body: dataToExport,
//             });
//             doc.save("time_to_hire.pdf");
//         });
//     });
// };

const exportPdf = () => {
  import("jspdf").then((jsPDF) => {
    import("jspdf-autotable").then(() => {
      const doc = new jsPDF.default("landscape");
      const dataToExport = getExportData();

      if (selectedJobs.length === 0) {
        toast.current.show({
          severity: 'info',
          summary: 'Info',
          detail: 'No rows selected, exporting all data to PDF.',
          life: 3000
        });
      }

      const exportColumns = [
        { title: "Job ID", dataKey: "job_number" },
        { title: "Job Title", dataKey: "job_title" },
        { title: "Job Posting Date", dataKey: "job_posting_date" },
        { title: "Job Start Date", dataKey: "job_start_date" },
        { title: "Job End Date", dataKey: "job_end_date" },
        { title: "Actual End Date", dataKey: "actual_end_date" },
        { title: "Number of Resumes", dataKey: "number_of_resumes" },
        { title: "Screening Start Date", dataKey: "screening_start_date" },
        { title: "Screening End Date", dataKey: "screening_end_date" },
        { title: "Interview Start Date", dataKey: "interview_start_date" },
        { title: "Interview End Date", dataKey: "interview_end_date" },
        // { title: "Offer Release Date", dataKey: "offer_release_date" },
        // { title: "Offer Acceptance Date", dataKey: "offer_acceptance_date" },
        { title: "Hiring Manager", dataKey: "hiring_manager" },
        { title: "Time to Hire (Days)", dataKey: "time_to_hire_days" },
        // { title: "Time to Fill (Days)", dataKey: "time_to_fill" }
      ];

      const formattedData = dataToExport.map(item => {
        const row = {};
        exportColumns.forEach(col => {
          row[col.dataKey] = item[col.dataKey] ?? '';
        });
        return row;
      });

      doc.autoTable({
        columns: exportColumns,
        body: formattedData,
        startY: 20,
        styles: { fontSize: 8, cellPadding: 2 },
        theme: "grid",
        margin: { top: 10, left: 5, right: 5 },
        columnStyles: { 0: { cellWidth: 30 } },
      });

      doc.save("time_to_hire.pdf");
    });
  });
};
   const exportExcel = () => {
    import('xlsx').then((xlsx) => {
        const dataToExport = getExportData();

        if (selectedJobs.length === 0) {
            toast.current.show({
                severity: 'info',
                summary: 'Info',
                detail: 'No rows selected, exporting all data to Excel.',
                life: 3000
            });
        }

        const formattedData = dataToExport.map(item => {
            const row = {};
            exportColumns.forEach(col => {
                row[col.title] = item[col.dataKey];
            });
            return row;
        });

        const headers = exportColumns.map(col => col.title);
        const worksheet = xlsx.utils.json_to_sheet(formattedData, { header: headers });
        worksheet['!cols'] = headers.map(header => ({ wch: Math.max(header.length, 10) }));

        const workbook = { Sheets: { 'Time to Hire': worksheet }, SheetNames: ['Time to Hire'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

        saveAsExcelFile(excelBuffer, 'time_to_hire');
    });
};


    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });
                module.default.saveAs(data, `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`);
            }
        });
    };

 const printFile = () => {
    const dataToExport = getExportData();

    const tableHeaders = exportColumns
        .map(col => `<th style="border: 1px solid #ccc; padding: 8px;">${col.title}</th>`)
        .join('');

    const tableRows = dataToExport.length > 0
        ? dataToExport
            .map(row => `<tr>${exportColumns
                .map(col => `<td style="border: 1px solid #ccc; padding: 8px;">${row[col.dataKey] ?? ''}</td>`)
                .join('')}</tr>`)
            .join('')
        : '<tr><td colspan="16" style="border: 1px solid #ccc; padding: 8px; text-align: center;">No data to print</td></tr>';

    const htmlContent = `
        <html>
        <head>
            <title>Print Time to Hire Report</title>
            <style>
                table { border-collapse: collapse; width: 100%; margin-top: 20px; }
                th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
                h2 { text-align: center; }
            </style>
        </head>
        <body>
            <h2>Time to Hire Report</h2>
            <table>
                <thead><tr>${tableHeaders}</tr></thead>
                <tbody>${tableRows}</tbody>
            </table>
        </body>
        </html>
    `;

    const printWindow = window.open('', '', 'height=600,width=900');
    printWindow.document.write(htmlContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
};


    return (
        <React.Fragment>
            <div className="page-content allact-tabs">
                <Container fluid={true}>
                    <Toast ref={toast} />
                    <div className="page-title-box actjobbread">
                        <Row className="align-items-center actjobsum">
                            <Col sm={6} md={6} lg={8}>
                                <h1 className="page-title">Time to Hire Report</h1>
                            </Col>
                            <Col sm={6} md={6} lg={4}>
                                <div className="allbtns d-flex gap-2 justify-content-end">
                                    <Button
                                        type="button"
                                        icon="pi pi-file"
                                        rounded
                                        onClick={exportCSV}
                                        tooltip="Export to CSV"
                                        tooltipOptions={{ position: 'left' }}
                                        className="csvbtn"
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-file-excel"
                                        severity="success"
                                        rounded
                                        onClick={exportExcel}
                                        tooltip="Export to XLS"
                                        tooltipOptions={{ position: 'top' }}
                                        className="xlsbtn"
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-file-pdf"
                                        severity="warning"
                                        rounded
                                        onClick={exportPdf}
                                        tooltip="Export to PDF"
                                        tooltipOptions={{ position: 'bottom' }}
                                        className="pdfbtn"
                                    />
                                    <Button
                                        type="button"
                                        icon="pi pi-print"
                                        severity="warning"
                                        rounded
                                        tooltip="Print"
                                        className="printbtn"
                                        tooltipOptions={{ position: 'bottom' }}
                                        onClick={printFile}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xxl={6}>
                                <h1 className="page-title mb-4"> </h1>
                            </Col>
                            <Col xxl={6}>
                                <div className="d-flex justify-content-end mt-2">
                                    <label className="mt-2 me-2">Select Company</label>
                                    <div className="mb-2 me-2" style={{ width: "170px" }}>
                                        <CompanySelector onCompanyChange={handleCompanyChange} />
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <section className="job-datatable-section">
                                    <div className="card1 mt-3 mb-4 actjobsumtable">
                                        {loading ? (
                                            <OrgTableShimmer columns={6} rows={7} titleWidth="220px" />
                                        ) : (
                                        <DataTable
                                            showGridlines
                                            ref={dt}
                                            value={timeToHire}
                                            tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                                            rows={rows}
                                            first={first}
                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                            onPage={onPage}
                                            dataKey="job_number"
                                            filters={filters}
                                            filterDisplay="row"
                                            loading={loading}
                                            globalFilterFields={[
                                                'job_id',
                                                'job_number',
                                                'job_title',
                                                'job_posting_date',
                                                'job_start_date',
                                                'job_end_date',
                                                'number_of_resumes',
                                                'screening_start_date',
                                                'screening_end_date',
                                                'interview_start_date',
                                                'interview_end_date',
                                                'offer_release_date',
                                                'offer_acceptance_date',
                                                'hiring_manager',
                                                'time_to_hire_days',
                                                'time_to_fill'
                                            ]}
                                            scrollable
                                            emptyMessage="No records found."
                                            selection={selectedJobs}
                                            onSelectionChange={onSelectionChange}
                                            selectionMode="multiple"
                                            totalRecords={timeToHire}
                                            resizableColumns
                                            columnResizeMode="expand"
                                            id="TimeToHireReport"
                                        >
                                            
                                            <Column field="job_number" sortable header="Job ID" filter filterPlaceholder="search by Job Id" style={{ minWidth: '10rem' }} />
                                            <Column field="job_title" sortable header="Job Title" filter filterPlaceholder="search by job title" style={{ minWidth: '10rem' }} />
                                            <Column field="job_posting_date" sortable header="Job Posting Date" filter filterPlaceholder="search by job posting date" style={{ minWidth: '10rem' }} />
                                            <Column field="job_start_date" sortable header="Job Start Date" filter filterPlaceholder="search by job start date" style={{ minWidth: '10rem' }} />
                                            <Column field="job_end_date" sortable header="Job End Date" filter filterPlaceholder="search by job end date" style={{ minWidth: '10rem' }} />
                                            <Column field="actual_end_date" sortable header="Actual End Date" filter filterPlaceholder="search by Actual End Date" style={{ minWidth: '10rem' }} />
                                            <Column field="number_of_resumes" sortable header="Number of Resumes" filter filterPlaceholder="search by Number of Resumes" style={{ minWidth: '10rem' }} />
                                            <Column field="screening_start_date" sortable header="Screening Start Date" filter filterPlaceholder="search by screening Start Date" style={{ minWidth: '10rem' }} />
                                            <Column field="screening_end_date" sortable header="Screening End Date" filter filterPlaceholder="search by screening End Date" style={{ minWidth: '10rem' }} />
                                            <Column field="interview_start_date" sortable header="Interview Start Date" filter filterPlaceholder="search by Interview Start Date" style={{ minWidth: '10rem' }} />
                                            <Column field="interview_end_date" sortable header="Interview End Date" filter filterPlaceholder="search by Interview End Date" style={{ minWidth: '10rem' }} />
                                            {/* <Column field="offer_release_date" sortable header="Offer Release Date" filter filterPlaceholder="search by Offer Release Date" style={{ minWidth: '10rem' }} /> */}
                                            {/* <Column field="offer_acceptance_date" sortable header="Offer Acceptance Date" filter filterPlaceholder="search by Offer Acceptance Date" style={{ minWidth: '10rem' }} /> */}
                                            <Column field="hiring_manager" sortable header="Hiring Manager" filter filterPlaceholder="search by Hiring Manager" style={{ minWidth: '10rem' }} />
                                            <Column field="time_to_hire_days" header="Time to Hire" sortable filter filterPlaceholder="search by Time to Hire" style={{ minWidth: '10rem' }} />
                                            {/* <Column field="time_to_fill" header="Time to Fill" sortable filter filterPlaceholder="search by Time to Fill" style={{ minWidth: '10rem' }} /> */}
                                        </DataTable>
                                         )}
                                    </div>
                                </section>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default TimeToHire;
